/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./gamescore.vue?vue&type=template&id=70ff53b0&scoped=true"
import script from "./gamescore.vue?vue&type=script&lang=js"
export * from "./gamescore.vue?vue&type=script&lang=js"
import style0 from "./gamescore.vue?vue&type=style&index=0&id=70ff53b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ff53b0",
  null
  
)

export default component.exports